import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { Storage } from '@ionic/storage';;
import { ApiService } from 'src/app/services/main/api.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { Cell, Img, PdfMakeWrapper, Stack, Table, Txt } from 'pdfmake-wrapper';
import * as fs from 'file-saver';
import { Workbook } from 'exceljs';
import { BaseCrudComponent } from '../../../base-crud/base-crud.component';
import { GlobalService } from '../../../../services/main/global.service';
import { AuthService } from '../../../../services/authentication/auth.service';
import { element } from 'protractor';

@Component({
  selector: 'app-settlements-dai',
  templateUrl: './settlements-dai.component.html',
  styleUrls: ['./settlements-dai.component.css']
})
export class SettlementsDaiComponent extends BaseCrudComponent implements OnInit {
  //Filter
  showIconF = false;
  dataSearchList = [];
  private workbook: Workbook;
  private lista_titulos;
  wareHouses = [];
  CompanyTrans = [];
  itemList = [];
  userList = [];
  TypeProduct = [];
  AgentUser = [];


  @ViewChild('thead', { static: true }) thead: ElementRef;
  userInfo;
  option_processes = null;
  origenList = environment.Global.COUNTRY;
  countryList = environment.Global.COUNTRY;
  date_init = null;
  date_end = null;
  type_product = "";
  name = 'Imports';

  translations;
  isFind = false;
  options_ruc = null;
  options_company = null;
  disabledCompany = false;
  disabledRuc = false;
  companies_list = [];
  ruc_list = [];
  request_selected = false;
  isSkretting = false;
  isClean = false;
  pageSize = 10;
  flag = false;

  col_value = 0;
  url_report_ = '';
  fontSize: number = 0;
  marginLeft: number = 30;
  l = [];
  userType = '';
  constructor(
    public GlobalService: GlobalService,
    private _authService: AuthService,
    public srv: ApiService,
    public modalService: NgbModal,
    public storage: Storage,
    public router: Router,
    private route: ActivatedRoute,
    public translate?: TranslateService,

  ) {
    super(srv, modalService, storage, router);
    this.search_fields = [

      'TypeProductName',
      'Agent',
      'ProcedureImportline',
      'OrderDisplay',
      'CompanyName',
      'ItemNumber',
      'ItemName',
      'Status',
      'GrossWeightDispatched',
      'EtdReal',
      'EtaReal',
      'Capacity',
      'CustomsAclarance',
      'DAI',
      'EmissionDate',
      'PaymentDateGuaranted',
      'PaymentDateEfectiveLq',
      'QuantityLiquidation',
      'Tariff',
      'TariffPercent',
      'SpecificTariff',
      'SpecificTariffPercent',
      'Fodinfa',
      'Iva',
      'Multa',
      'TariffHeading',
      'CodeAdv',
      'CodeIva',
      'Antidumping',
      'AdvaloremICE',
      'SpecificICE',
      'Safeguard',
      'SpecificSafeguard',
      'RedeemableTax',
      'Reference',
      'Commentary',

    ];
  }

  async ngOnInit() {
    this.user = this._authService.getUserLogged();
    this.userType = this._authService.ExistPermission("CX_ADM") ? 'ADM'
      : this._authService.ExistPermission("CX_AGA") ? 'AGA'
        : this._authService.ExistPermission("CX_TRA") ? 'TRA'
          : this._authService.ExistPermission("CX_FIN") ? 'FIN'
            : this._authService.ExistPermission("CX_TAX") ? 'TAX'
              // : this._authService.ExistPermission("CX_CAL") ? 'CAL'
              : this._authService.ExistPermission("CX_COM") ? 'COM'
                : this._authService.ExistPermission("CX_CM") ? 'CM' : 'ADM';
    // this.userType = "AGA"; // USER TYPE AGENTE DE ADUANA PARA PRUEBAS
    this.user = this._authService.getUserLogged();
    // this.user.sub = "4298"  // CODIGO DE AGENTE DE ADUANA PARA PRUEBAS
    // console.log(this.user)
    // console.log(this.userType)

    // this.u_obj['UserId'] = "0";
    this.AgentUser = [];
    await super.ngOnInit();
    await this.getInternalUser();
    await this.GetTypeProductActive();
    await this.GetAgentUserActive();
    this.getNotificationAP(this.user.sub);
    this.getNotificationAC(this.user.sub);
    this.getNotificationCXP(this.user.sub);
    this.getNotificationCP(this.user.sub);
    this.getNotificationCA(this.user.sub);
    this.translate.getTranslation(this.translate.currentLang)
      .subscribe((translations) => {
        this.translations = translations;
      });

    if (this.request_selected) {
      this.disabledCompany = false;
      this.disabledRuc = false;
    } else {
      this.disabledCompany = true;
      this.disabledRuc = true;
    }
  }
  public async getInternalUser() {
    this.url = environment.Global.API_GET_USER_INT;
    await this.srv.get(this.url).toPromise().then(result => {
      if (result.Status) {
        this.userList = result.Object;
      }
    })
  }
  public async GetTypeProductActive() {
    this.url = environment.Global.API_GET_ACTIVE_TP;
    await this.srv.get(this.url).toPromise().then(result => {
      if (result.Status) {
        this.TypeProduct = result.Object;
      }
    })
  }
  public async GetAgentUserActive() {
    // CODIGO DE UN AGENTE DE ADUANA.
    this.url = environment.Global.API_GET_REPORT_GET_AGENT_USER;
    await this.srv.get(this.url).toPromise().then(result => {
      if (result.Status) {
        console.log(result.Object)

        if (this.userType == "AGA") {
          result.Object.forEach(element => {
            if (element.UserCode == this.user.sub) {
              debugger
              // this.UserId = element.UserId;
              this.u_obj['UserId'] = element.UserId;
              this.AgentUser.push(element);

            }
          });

        } else {
          this.u_obj['UserId'] = "0"
          this.AgentUser = result.Object;
        }

      }
    })
  }
  clearFilters() {

    this.u_obj['UserId'] = "0"
    this.rows = [];
    this.rawdata = [];
    this.isFind = false;
    this.page = 0;
    this.url_report_ = '';
    this.disabledCompany = true;
    this.disabledRuc = true;
    this.date_end = null;
    this.date_init = null;
    // console.log(this.options_company);
    // console.log(this.options_ruc);
  }
  dataToFind() {
    this.isFind = true;
    this.showIconF = false;


    // if (this.u_obj['ItemId'] == "0" || this.u_obj['ItemId'] == null) {
    //   this.u_obj['ItemId'] = "0";
    // }

    // if (this.date_init == null || this.date_end == null) {

    //   this.isFind = false;
    //   return Swal.fire("Error", this.translations.msg_error_empty, 'error');
    // }

    this.setUrlToFindData();
  }
  async setUrlToFindData() {
    this.isFind = false;
    await this.getListFromApi();
  }
  formatOnlyDate(date: Date) {
    return date.getFullYear().toString() + '-' + (date.getMonth() < 10 ? `0${(date.getMonth() + 1).toString()}` : (date.getMonth() + 1).toString()) + '-' + (date.getDate() <= 9 ? `0${date.getDate().toString()}` : date.getDate().toString());
  }
  async getListFromApi() {
    // console.log(this.option_processes);
    this.isFind = true;

    this.url = environment.Global.API_GET_REPORT_SETTLMENT_DAI + this.userType + '/' + this.user.sub;
    console.log(this.url)
    let list_tmp = [];
    // console.log( this.date_init, this.date_end, this.option_processes,this.options_ruc, this.options_company);
    this.messageShowLoading();

    await this.srv.getCall(this.url).subscribe(x => {
      if (x.Status) {
        if (x.Object != null) {

          // console.log(x.Object);
          this.rawdata = x.Object;
          let new_list = [];
          list_tmp = x.Object;

          list_tmp.forEach(element => {

            if (element.TypeProduct != null) {
              this.TypeProduct.forEach(product => {
                if (product.id == element.TypeProduct) {
                  element.TypeProductName = product.nombre;
                }
              });

            } else {
              element.TypeProductName = "";
            }

          });


          if (this.date_init == null && this.date_end == null && this.u_obj['UserId'] == "0") {
            this.rows = list_tmp
          } else {
            debugger
            list_tmp.forEach(tmp => {
              debugger
              tmp.UserIds = tmp.UserIds == null ? '' : tmp.UserIds;
              tmp.List = tmp.UserIds.includes(',') ? tmp.UserIds.split(',') : [tmp.UserIds];

              tmp.List.forEach(element => {


                if (tmp.EmissionDate != null && tmp.EmissionDate >= this.date_init && tmp.EmissionDate <= this.date_end || element == this.u_obj['UserId']) {
                  new_list.push(tmp);
                }
              });

            })
            this.rawdata = new_list;
            this.rows = new_list;
          }


          this.page = 1;
          if (Array.isArray(this.rows)) {
            this.pageTotal = this.rows.length;
          }
          this.closeMessageDialog();
          this.filterAll();
          this.isFind = false;
          if (this.rows.length === 0) {
            Swal.fire(this.translations.empty, this.translations.not_registers, 'success');
          }
        } else {
          Swal.fire(this.translations.empty, this.translations.not_registers, 'success');
          this.isFind = false;
          return;
        }
      } else {
        this.isFind = false;
        Swal.fire(x.Message, '', 'error');
        return;
      }
    });

  }
  public showIconFilter(flag: boolean) {
    this.showIconF = flag;
    if (!flag) {
      this.searchData('');
      // this.arrayList = [];
    }

  }
  public searchData(event) {
    this.search = event;
    this.filterAll();
  }

  public resetData(index, columnName) {
    let array = [];
    this.l[index] = [];
    this.rows.forEach(element => {
      if (element[columnName] != undefined) {
        let flag = array.indexOf(element[columnName]);
        if (flag == -1) {
          array.push(element[columnName]);
        }
      }
    });

    array.push('(Vacíos)');
    this.l[index] = array;
  }

  public searchDataSelect(event) {
    let data = event.split('|'); debugger;
    if (data[2] == '(Vacíos)') {
      data[2] = null;
    }
    this.dataSearchList[data[0]] = data[2] != '' ? (data[1] + '|' + data[2]) : null;//''
    this.search2 = this.dataSearchList;
    this.filterAllSelect();
  }
  async reports() {
    this.l = [];
    this.rows.forEach(element => {
      if (this.rows !== null && this.rows !== ' ') {
        let obj = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', //,'',''
          '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
          '', '', '', '', '', '']//,'',''

        // obj[12] = "" != null ? .EtaReal.split('T')[0] : "";

        obj[0] = element.TypeProductName;
        obj[1] = element.AgentName;
        obj[2] = element.ProcedureImportline;
        obj[3] = element.OrderDisplay;
        obj[4] = element.CompanyName;
        obj[5] = element.ItemNumber;
        obj[6] = element.ItemName;
        obj[7] = element.StatusName;
        obj[8] = element.GrossWeightDispatched;
        obj[9] = element.EtdReal != null ? element.EtdReal.split('T')[0] : "";
        obj[10] = element.EtaReal != null ? element.EtaReal.split('T')[0] : "";
        obj[11] = element.Capacity;
        obj[12] = element.CustomsAclarance;
        obj[13] = element.DAI;
        obj[14] = element.EmissionDate != null ? element.EmissionDate.split('T')[0] : "";
        obj[15] = element.PaymentDateGuaranted != null ? element.PaymentDateGuaranted.split('T')[0] : "";;
        obj[16] = element.PaymentDateEfectiveLq != null ? element.PaymentDateEfectiveLq.split('T')[0] : "";;
        obj[17] = element.QuantityLiquidation;
        obj[18] = element.Tariff;
        obj[19] = element.TariffPercent;
        obj[20] = element.SpecificTariff;
        obj[21] = element.SpecificTariffPercent;
        obj[22] = element.Fodinfa;
        obj[23] = element.Iva;
        obj[24] = element.Multa;
        obj[25] = element.TariffHeading;
        obj[26] = element.CodeAdv;
        obj[27] = element.CodeIva;
        obj[28] = element.Antidumping;
        obj[29] = element.ICEAdvalorem;
        obj[30] = element.ICESpecific;
        obj[31] = element.Safeguard;
        obj[32] = element.SafeguardSpecific;
        obj[33] = element.RedeemableTax;
        obj[34] = element.TPNReference;
        obj[35] = element.Observacion;



        this.l.push(obj)
      }

    });
  }

  async converDataToRow(list) {
    let nueva_lista = [];
    this.reports();
    if (this.rows !== null && this.rows !== ' ') {
      nueva_lista = this.l;
      return nueva_lista;
    }
  }

  async downloadReport() {
    debugger
    Swal.fire(
      {
        title: this.translations['download_report'],
        html: '',
        icon: 'info',
      }
    );
    Swal.showLoading();

    let listInReport = this.rows;
    const pdf = new PdfMakeWrapper();
    let nameDoc = '';
    let title = '';
    let lista_titulos = [];
    let lista_widths = [];


    title = 'Reporte de Liquidaciones - DAI';

    lista_titulos = [
      // new Cell(new Txt("ID").margin([0, 5, 0, 5]).color('white').bold().end).end,
      new Cell(new Txt(this.translations.Category).margin([0, 5, 0, 5]).color('white').bold().end).end,
      new Cell(new Txt(this.translations.Agent).margin([0, 5, 0, 5]).color('white').bold().end).end,
      new Cell(new Txt(this.translations.ProcedureImportline).margin([0, 5, 0, 5]).color('white').bold().end).end,
      new Cell(new Txt(this.translations.OrderDisplay).margin([0, 5, 0, 5]).color('white').bold().end).end,
      new Cell(new Txt(this.translations.CompanyName).margin([0, 5, 0, 5]).color('white').bold().end).end,
      new Cell(new Txt(this.translations.ItemNumber).margin([0, 5, 0, 5]).color('white').bold().end).end,
      new Cell(new Txt(this.translations.ItemName).margin([0, 5, 0, 5]).color('white').bold().end).end,
      new Cell(new Txt(this.translations.Status).margin([0, 5, 0, 5]).color('white').bold().end).end,
      new Cell(new Txt(this.translations.GrossWeightDispatched).margin([0, 5, 0, 5]).color('white').bold().end).end,
      new Cell(new Txt(this.translations.EtdReal).margin([0, 5, 0, 5]).color('white').bold().end).end,
      new Cell(new Txt(this.translations.EtaReal).margin([0, 5, 0, 5]).color('white').bold().end).end,
      new Cell(new Txt(this.translations.Capacity).margin([0, 5, 0, 5]).color('white').bold().end).end,
      new Cell(new Txt(this.translations.CustomsAclarance).margin([0, 5, 0, 5]).color('white').bold().end).end,
      new Cell(new Txt("DAI").margin([0, 5, 0, 5]).color('white').bold().end).end,
      new Cell(new Txt(this.translations.EmissionDate).margin([0, 5, 0, 5]).color('white').bold().end).end,
      new Cell(new Txt(this.translations.PaymentDateGuaranted).margin([0, 5, 0, 5]).color('white').bold().end).end,
      new Cell(new Txt(this.translations.PaymentDateEfectiveLq).margin([0, 5, 0, 5]).color('white').bold().end).end,
      new Cell(new Txt(this.translations.QuantityLiquidation).margin([0, 5, 0, 5]).color('white').bold().end).end,
      new Cell(new Txt(this.translations.Tariff).margin([0, 5, 0, 5]).color('white').bold().end).end,
      new Cell(new Txt(this.translations.TariffPercent).margin([0, 5, 0, 5]).color('white').bold().end).end,
      new Cell(new Txt(this.translations.SpecificTariff).margin([0, 5, 0, 5]).color('white').bold().end).end,
      new Cell(new Txt(this.translations.SpecificTariffPercent).margin([0, 5, 0, 5]).color('white').bold().end).end,
      new Cell(new Txt(this.translations.Fodinfa).margin([0, 5, 0, 5]).color('white').bold().end).end,
      new Cell(new Txt(this.translations.Iva).margin([0, 5, 0, 5]).color('white').bold().end).end,
      new Cell(new Txt("Multa").margin([0, 5, 0, 5]).color('white').bold().end).end,
      new Cell(new Txt(this.translations.TariffHeading).margin([0, 5, 0, 5]).color('white').bold().end).end,
      new Cell(new Txt(this.translations.CodeAdv).margin([0, 5, 0, 5]).color('white').bold().end).end,
      new Cell(new Txt(this.translations.CodeIva).margin([0, 5, 0, 5]).color('white').bold().end).end,
      new Cell(new Txt(this.translations.Antidumping).margin([0, 5, 0, 5]).color('white').bold().end).end,
      new Cell(new Txt(this.translations.AdvaloremICE).margin([0, 5, 0, 5]).color('white').bold().end).end,
      new Cell(new Txt(this.translations.SpecificICE).margin([0, 5, 0, 5]).color('white').bold().end).end,
      new Cell(new Txt(this.translations.Safeguard).margin([0, 5, 0, 5]).color('white').bold().end).end,
      new Cell(new Txt(this.translations.SpecificSafeguard).margin([0, 5, 0, 5]).color('white').bold().end).end,
      new Cell(new Txt(this.translations.RedeemableTax).margin([0, 5, 0, 5]).color('white').bold().end).end,
      new Cell(new Txt("TPN " + this.translations.Reference).margin([0, 5, 0, 5]).color('white').bold().end).end,
      new Cell(new Txt(this.translations.Commentary).margin([0, 5, 0, 5]).color('white').bold().end).end,

    ];
    lista_widths = [
      'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto',
      'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto',
      'auto', 'auto', 'auto', 'auto', 'auto', 'auto'
    ]

    // INFORMATION IN TITLE NAV
    pdf.info({
      title: `${title}`,
      author: `${"Skretting"}`,//this.userInfo.name
      subject: 'Listado',
    });

    //OPTIONS
    this.fontSize = 4;
    this.marginLeft = 3;


    pdf.defaultStyle({
      bold: false,
      fontSize: this.fontSize,
      alignment: 'justify'
    });

    pdf.pageMargins([10, 110, 10, 110]);

    pdf.pageOrientation("landscape");
    pdf.background(
      await new Img('../../../../assets/images/Skretting-footer.png').absolutePosition(0, 515).width(900).build() //505
    )


    pdf.header(
      new Table(
        [
          [
            new Cell(await new Img('../../../../assets/images/Skretting-logo.png').width('160').build()).end,
          ]
        ]
      )
        .margin([this.marginLeft, 30, 30, 0])
        .alignment('right')
        .layout('noBorders')
        .widths('*')
        .end,
    );

    pdf.add(
      [
        new Txt(title).fontSize(14).bold().margin([0, 0, 0, 20]).alignment('center').end,
        new Table(
          [
            lista_titulos,
            ...await this.converDataToRow(listInReport)
          ]
        ).layout({
          fillColor: (rowIndex: number, node: any, columnIndex: number) => {
            return rowIndex === 0 ? '#f62d51' : '';
          },
        })
          .headerRows(1)
          .dontBreakRows(true)
          .fontSize(this.fontSize)
          .widths(lista_widths)
          // .widths('*')
          .alignment('center')
          .end,
      ]
    )

    pdf.footer(function (currentPage, pageCount) {
      return new Stack(
        [
          new Cell(new Txt('Skretting Ecuador | Km 4.5 & 6.5 vía Durán - Tambo. Durán - Ecuador | Telf: + 593 4 2598100 + 593 4 2815737').fontSize(8).color('gray').alignment('center').margin([0, 10, 0, 0]).end).end,
          new Cell(new Txt('www.skretting.ec').link('https://www.skretting.com/es-ec/').fontSize(8).color('gray').alignment('center').end).end,
          new Cell(new Txt(' Página ' + currentPage.toString() + ' de ' + pageCount).bold().alignment('right').fontSize(9).color('white').margin([0, 40, 20, 0]).end).end
        ]
      ).end
    });

    pdf.create().download(title);
    Swal.close();
  }
  downloadExcel() {

    this.workbook = new Workbook();
    let nombreXLSX = "Reporte de Liquidaciones-DAI.xlsx";
    this.lista_titulos = [


      this.translations.Category,
      this.translations.Agent,
      this.translations.ProcedureImportline,
      this.translations.OrderDisplay,
      this.translations.CompanyName,
      this.translations.ItemNumber,
      this.translations.ItemName,
      this.translations.Status,
      this.translations.GrossWeightDispatched,
      this.translations.EtdReal,
      this.translations.EtaReal,
      this.translations.Capacity,
      this.translations.CustomsAclarance,
      "DAI",
      this.translations.EmissionDate,
      this.translations.PaymentDateGuaranted,
      this.translations.PaymentDateEfectiveLq,
      this.translations.QuantityLiquidation,
      this.translations.Tariff,
      this.translations.TariffPercent,
      this.translations.SpecificTariff,
      this.translations.SpecificTariffPercent,
      this.translations.Fodinfa,
      this.translations.Iva,
      "Multa",
      this.translations.TariffHeading,
      this.translations.CodeAdv,
      this.translations.CodeIva,
      this.translations.Antidumping,
      this.translations.AdvaloremICE,
      this.translations.SpecificICE,
      this.translations.Safeguard,
      this.translations.SpecificSafeguard,
      this.translations.RedeemableTax,
      "TPN " + this.translations.Reference,
      this.translations.Commentary,
    ];

    this.ContainsExcel();
    this.workbook.creator = "Comex";
    this.workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data]);
      fs.saveAs(blob, nombreXLSX);
    })
  }
  private ContainsExcel() {
    const sheet = this.workbook.addWorksheet('Sheet');

    sheet.getColumn("A").width = 20;
    sheet.getColumn("B").width = 20;
    sheet.getColumn("C").width = 20;
    sheet.getColumn("D").width = 20;
    sheet.getColumn("E").width = 20;
    sheet.getColumn("F").width = 20;
    sheet.getColumn("G").width = 20;
    sheet.getColumn("H").width = 20;
    sheet.getColumn("I").width = 20;
    sheet.getColumn("J").width = 20;
    sheet.getColumn("K").width = 20;
    sheet.getColumn("L").width = 20;
    sheet.getColumn("M").width = 20;
    sheet.getColumn("N").width = 20;
    sheet.getColumn("O").width = 20;
    sheet.getColumn("P").width = 20;
    sheet.getColumn("Q").width = 20;
    sheet.getColumn("R").width = 20;
    sheet.getColumn("S").width = 20;
    sheet.getColumn("T").width = 20;
    sheet.getColumn("U").width = 20;
    sheet.getColumn("V").width = 20;
    sheet.getColumn("W").width = 20;
    sheet.getColumn("X").width = 20;
    sheet.getColumn("Y").width = 20;
    sheet.getColumn("Z").width = 20;
    sheet.getColumn("AA").width = 20;
    sheet.getColumn("AB").width = 20;
    sheet.getColumn("AC").width = 20;
    sheet.getColumn("AD").width = 20;
    sheet.getColumn("AE").width = 20;
    sheet.getColumn("AF").width = 20;
    sheet.getColumn("AG").width = 20;
    sheet.getColumn("AH").width = 20;
    sheet.getColumn("AI").width = 20;
    sheet.getColumn("AJ").width = 20;
    sheet.getColumn("AK").width = 20;

    // ALINEAR COLUMNAS
    sheet.columns.forEach((column) => {
      column.alignment = { vertical: 'middle', wrapText: true }
      column.alignment = { vertical: 'middle', wrapText: true }
    });



    // establecer los valores de las columnas y del header

    //establecer los header
    const headerRow = sheet.getRow(1);
    // console.log("Lista de titulos:", this.lista_titulos);
    headerRow.values = this.lista_titulos;
    // headerRow.values = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
    headerRow.font = { bold: true, size: 12 };

    // agregar los datos a las filas
    const rowsToInsert = sheet.getRows(2, this.rows.length);

    for (let index = 0; index < rowsToInsert.length; index++) {
      const element = this.rows[index]; //obtenemos el item segun el index de la iteraciòn(recorrido)
      const row = rowsToInsert[index]; //obtenemos la primera fila segun el index de la iteraciòn(recorrido)
      // los valores de itemData seran asignados a row (fila actual en la iteraciòn)


      row.values = [

        // itemData.TypeProductName,
        element.TypeProductName,
        element.AgentName,
        element.ProcedureImportline,
        element.OrderDisplay,
        element.CompanyName,
        element.ItemNumber,
        element.ItemName,
        element.StatusName,
        element.GrossWeightDispatched,
        element.EtdReal != null ? element.EtdReal.split('T')[0] : "",
        element.EtaReal != null ? element.EtaReal.split('T')[0] : "",
        element.Capacity,
        element.CustomsAclarance,
        element.DAI,
        element.EmissionDate != null ? element.EmissionDate.split('T')[0] : "",
        element.PaymentDateGuaranted != null ? element.PaymentDateGuaranted.split('T')[0] : "",
        element.PaymentDateEfectiveLq != null ? element.PaymentDateEfectiveLq.split('T')[0] : "",
        element.QuantityLiquidation,
        element.Tariff,
        element.TariffPercent,
        element.SpecificTariff,
        element.SpecificTariffPercent,
        element.Fodinfa,
        element.Iva,
        element.Multa,
        element.TariffHeading,
        element.CodeAdv,
        element.CodeIva,
        element.Antidumping,
        element.ICEAdvalorem,
        element.ICESpecific,
        element.Safeguard,
        element.SafeguardSpecific,
        element.RedeemableTax,
        element.TPNReference,
        element.Observacion,
      ];
    }
  }
}
